import { AssistantType } from '@vendasta/protos/ai_assistants/v1alpha1';

const LABEL_KEYS: Partial<Record<AssistantType, string>> = {
  [AssistantType.ASSISTANT_TYPE_SYSTEM]: 'SYSTEM',
  [AssistantType.ASSISTANT_TYPE_INBOX]: 'INBOX',
  [AssistantType.ASSISTANT_TYPE_SOCIAL_MARKETING]: 'SOCIAL_MARKETING',
  [AssistantType.ASSISTANT_TYPE_VOICE_RECEPTIONIST]: 'VOICE_RECEPTIONIST',
  [AssistantType.ASSISTANT_TYPE_CUSTOM]: 'CUSTOM',
  [AssistantType.ASSISTANT_TYPE_SALES_COACH]: 'SALES_COACH',
  [AssistantType.ASSISTANT_TYPE_REPUTATION_MANAGEMENT_REVIEW_AGENT]: 'REVIEW_MANAGER',
  [AssistantType.ASSISTANT_TYPE_MARKETER]: 'MARKETER',
  [AssistantType.ASSISTANT_TYPE_AEO_AND_SEO_EXPERT]: 'AI_SEARCH_SPECIALIST',
  [AssistantType.ASSISTANT_TYPE_BLOGGER]: 'BLOGGER',
  [AssistantType.ASSISTANT_TYPE_BUSINESS_APP_ASSISTANT]: 'BUSINESS_APP',
  [AssistantType.ASSISTANT_TYPE_GENERATION]: 'GENERATION',
  [AssistantType.ASSISTANT_TYPE_A2P]: 'A2P',
};

/**
 * Translation key for an assistant type, or null when there is nothing worth showing
 * (unspecified, or a type added to the proto but not yet to the map).
 */
export function assistantTypeLabelKey(type: AssistantType | undefined): string | null {
  if (type === undefined) return null;
  const suffix = LABEL_KEYS[type];
  return suffix ? `AI_ASSISTANT.SHARED.ASSISTANT_TYPES.${suffix}` : null;
}
